import styled from 'styled-components';

const Row = styled.div`
  flex: 1;
  display: flex;
  overflow-y: auto;
`;

const DetailsColumn = styled.div`
  flex: 1;
  margin-left: 1em;
  display: flex;
  flex-direction: column;
`;

const ActionsColumn = styled.div`
  margin-left: 1em;
  display: flex;
  flex-direction: column;

  & > * {
    display: flex;
    align-items: center;
  }
`;

export default {
  Row,
  DetailsColumn,
  ActionsColumn,
};
